import { Link } from '@remix-run/react'

export const flashActive = true

export const FlashContent = () => (
  <>
    <strong>
      ❄️ Meet our team at <Link to="/snowflake">Snowflake Summit</Link> ❄️
    </strong>
  </>
)
